import React from "react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import config from "../config";
import axios from "axios";
import DOMPurify from "dompurify";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { LazyLoadImage } from "react-lazy-load-image-component";
import placeholderimage from "../image/placeholder.jpg";

export default function BlogDetail() {
  const [blogDetail, blogDetailState] = useState([]);
  const params = useParams();
  const [blogList, setBlogList] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    axios
      .get(`${config.apiUrl}/blog/${params.slug}`)
      .then((res) => {
        blogDetailState(res.data.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [params.slug]);

  useEffect(() => {
    axios
      .get(`${config.apiUrl}/blog`)
      .then((res) => {
        const sortedBlogs = (res.data.data || []).sort(
          (a, b) => new Date(b.date) - new Date(a.date)
        );
        // Get the latest 4 blog posts
        const latestBlogs = sortedBlogs.slice(0, 4);
        setBlogList(latestBlogs);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <div className="container-fluid blog-list-container">
        <HelmetProvider>
          <Helmet>
            <title>{blogDetail.meta_title || blogDetail.title || "Blog | MeraGym"}</title>
            <meta name="keywords" content={blogDetail.meta_keyword} />
            <meta name="description" content={blogDetail.meta_description} />
            {blogDetail.slug && (
              <link rel="canonical" href={`https://meragym.com/blog/${blogDetail.slug}`} />
            )}
            <meta property="og:title" content={blogDetail.meta_title || blogDetail.title} />
            <meta property="og:description" content={blogDetail.meta_description} />
            <meta property="og:type" content="article" />
            {blogDetail.slug && (
              <meta property="og:url" content={`https://meragym.com/blog/${blogDetail.slug}`} />
            )}
            {blogDetail.image && (
              <meta property="og:image" content={blogDetail.image} />
            )}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={blogDetail.meta_title || blogDetail.title} />
            <meta name="twitter:description" content={blogDetail.meta_description} />
          </Helmet>
        </HelmetProvider>
        <div className="container mb-3">
          <div className="row">
            <div className="col-sm-12 col-lg-8">
              <section className="blog-list-section">
                <h1 className="offHead blog-head">{blogDetail.title}</h1>
                <span className="d-flex flex-row">
                  <i className="bi bi-person-fill text-secondary"></i>
                  <p className="text-secondary ms-2 p-0">
                    {blogDetail.created_by},
                  </p>
                  <p className="text-secondary my-0 ms-2">
                    {blogDetail.created_at}
                  </p>
                </span>
                <div className="justify-content-center">
                  <LazyLoadImage
                    src={blogDetail.image}
                    placeholderSrc={placeholderimage}
                    loading="lazy"
                    alt={blogDetail.title || "Blog article image"}
                    className="blog-detail-img"
                  />
                </div>

                <div
                  className="blog-text blog-in-img mt-3"
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blogDetail.description || "") }}
                />

                <ul className="keyword">
                  <li>Gyms</li>
                  <li>Exercise</li>
                  <li>Workout</li>
                  <li>Gyms</li>
                  <li>Exercise</li>
                  <li>Workout</li>
                  <li>Gyms</li>
                  <li>Exercise</li>
                  <li>Workout</li>
                  <li>Gyms</li>
                  <li>Exercise</li>
                  <li>Workout</li>
                </ul>
              </section>
            </div>

            <div className="col-sm-12 col-lg-4">
              <section className="blog-related-section">
                <h5 className="text-start pb-2 border-bottom border-primary">
                  Related Blog :-
                </h5>
                {blogList.map((data) => {
                  return (
                    <Link to={`/blog/${data.slug}`} className="rel-link" key={data.id}>
                      <div className="card border-0 blog-list-card d-flex flex-row mt-3">
                        <div className="card-body">
                          <p className="related-txt">
                            {data.title}
                          </p>
                        </div>
                        <img
                          src={data.image}
                          alt={data.title || "Related blog article"}
                          className="blog-categ-img"
                        />
                      </div>
                    </Link>
                  );
                })}
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
